import { render, staticRenderFns } from "./V2AddressDetail.vue?vue&type=template&id=072781d8&scoped=true&"
import script from "./V2AddressDetail.vue?vue&type=script&lang=js&"
export * from "./V2AddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./V2AddressDetail.vue?vue&type=style&index=0&id=072781d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072781d8",
  null
  
)

export default component.exports